"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_tooltip_1 = __importDefault(require("react-tooltip"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const StyledContainer = styled_components_1.default.div `
  font-family: Nimbus Sans Regular;
  .custom-tooltip {
    box-shadow: 0 16px 16px 0 rgba(45, 57, 64, 0.06),
      0 0 8px 0 rgba(45, 57, 64, 0.06);
    color: ${tokens.ColorGrey900};
    font-family: Nimbus Sans Regular;
    line-height: 1.38;
    opacity: 1 !important;
    position: absolute;
  }
`;
class Tooltip extends react_1.Component {
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledContainer, null,
                react_1.default.createElement(react_tooltip_1.default, Object.assign({ className: "custom-tooltip", arrowColor: tokens.ColorWhite000, html: true, type: "light", effect: "float", backgroundColor: "white" }, this.props)))));
    }
}
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map